// @flow

import {
  ModalProps,
  ModalContentProps,
  ModalHeaderProps,
  ModalBodyProps,
  ModalFooterProps,
  IconButtonProps,
  IconProps,
  TextProps,
  InputProps,
  ButtonProps,
  StackProps,
  BoxProps,
  SystemCSSProperties,
} from "@chakra-ui/react";

export const modal: ModalProps = {
  isCentered: true,
  size: "xl",
  motionPreset: "slideInRight",
  scrollBehavior: "inside",
};

export const content: ModalContentProps = {
  background: "unifize_blueDark",
  height: "75vh",
};

export const header: ModalHeaderProps = {
  borderTopRadius: "8px",

  height: "40px",
  px: 4,
  py: 2,

  background: "unifize_blueDark",

  color: "unifize_skyLighter",
  fontSize: "md",
  fontWeight: "bold",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const closeIconButton: IconButtonProps = {
  background: "transparent",
  color: "unifize_skyLighter",

  _hover: {
    background: "transparent",
    color: "unifize_skyLighter",
  },

  _focus: {
    boxShadow: "none",
  },
};

export const closeIcon: IconProps = {
  background: "transparent",
  color: "unifize_skyLighter",
};

export const body: ModalBodyProps = {
  background: "white",
  p: 4,
  pb: "0 !important",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  gridGap: 3,
  height: "100%",
};

export const subjectInput: InputProps = {
  size: "xs",
  fontSize: "14px",
  border: "none",
  _focus: {
    border: "none",
  },
};

export const unstyledButtonLink: ButtonProps = {
  variant: "link",
  bg: "transparent",
  color: "unifize_inkLighter",
  fontSize: "14px",
  fontWeight: 400,
  _focus: {
    boxShadow: "none",
  },
};

export const formItemFrame: StackProps = {
  width: "100%",
  pb: 1,
  borderBottom: "1px",
  borderColor: "unifize_skyDark",
};

export const formLabel: TextProps = {
  fontSize: "14px",
  color: "unifize_inkLighter",
  my: 0,
};

export const searchResultFrame: BoxProps = {
  position: "absolute",
  zIndex: 2999,
  background: "white",
  width: "250px",
};

export const usersDropdown: StackProps = {
  border: "1px",
  borderRadius: "2px",
  borderColor: "unifize_secondary",
  boxShadow: "1px 1px 10px rgba(21, 129, 186, 0.2)",
  alignItems: "start",
  p: 2,
  maxHeight: "200px",
  overflow: "auto",
  cursor: "pointer",
};

export const addButtonText: TextProps = {
  my: 0,
  fontSize: "14px",
  fontWeight: 600,
  isTruncated: true,
};

export const messageContainer: SystemCSSProperties = {
  alignItems: "start",
  justifyContent: "space-between",
  spacing: 2,
  width: "100%",
  height: "100%",
  overflow: "auto",
};

export const messageEditor = {
  width: "100%",
};

export const filePickerFrame: StackProps = {
  alignItems: "start",
  position: "absolute",
  bottom: "0px",
  right: "150px",
  background: "unifize_brightLight",
  boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
  spacing: 2,
  p: 2,
  borderRadius: "4px",
  width: "300px",
};

export const fileSource: StackProps = {
  spacing: 5,
  p: 2,
  cursor: "pointer",
  _hover: {
    background: "unifize_grey2",
  },
};

export const footer: ModalFooterProps = {
  borderBottomRadius: "8px",
  background: "white",
};
